import {removeSupplierFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

export function removeSupplierFunctionMutationOptions(supplierId: string) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.removeSupplierFunction,
    mutationFn: (functionId: string) => removeSupplierFunction(supplierId, functionId),
    onSuccess: async (_data, _functionId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
